import { getBaseUrl } from '@/api/helpers'
import type { CreateClientConfig } from '@hey-api/client-axios'

// Collection API is public: identity travels via link_token + X-Session-Token,
// not cookies. Keeping withCredentials/CSRF would only add CORS risk in prod.
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseURL: `${getBaseUrl()}/collection/v1`,
  headers: {
    'Content-Type': 'application/json',
    // Leave Accept-Language unset so the browser sends its own. Setting it empty overrode that and probing fell back to English.
  },
  timeout: 90000,
  withCredentials: false,
  validateStatus(status: number) {
    return status >= 200 && status < 300
  },
})
